module.exports = __webpack_public_path__ + "img/doAccount.544cd202.png";